import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 35,
	viewBox: "0 0 38 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4098 33.2148C32.8649 33.624 35.7869 33.874 35.834 31.6008C35.8928 28.7593 24.1541 30.221 31.4098 33.2148Z",
			fill: "#DADADA",
			stroke: "#DADADA",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5051 13.8444C26.7471 13.0907 28.904 11.2419 27.5956 9.87672C25.9602 8.17018 18.7497 17.0438 25.5051 13.8444Z",
			fill: "#DADADA",
			stroke: "#DADADA",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.30408 4.45486C2.05724 5.88654 2.03574 8.72723 3.9245 8.63664C6.28546 8.52339 4.32584 -2.74128 2.30408 4.45486Z",
			fill: "#DADADA",
			stroke: "#DADADA",
			strokeWidth: 3,
			strokeLinecap: "round"
		})
	]
});
const SvgDotsDoodle = styled(base)({});
export default SvgDotsDoodle;
